import React, { useState, useEffect, useCallback } from "react";
import { Link, useLocation, Outlet, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiLogOut,
  FiMenu,
  FiChevronDown,
  FiArrowLeft,
  FiX,
  FiGift,
} from "react-icons/fi";
import { GoPackage } from "react-icons/go";
import { FaCrown, FaGavel, FaUser } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { AiFillStar, AiOutlinePhone } from "react-icons/ai";
import { GiDiamondTrophy } from "react-icons/gi";
import { motion, AnimatePresence } from "framer-motion";
import { RiCoinsLine } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
import {
  MdOutlineEditCalendar,
  MdPersonAdd,
  MdPhotoLibrary,
  MdArticle,
} from "react-icons/md";
import { BiLineChart } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { setValue } from "../../features/UserInfo/userSlice";

const AdminLayout = ({ setIsRefresh }) => {
  const userData = useSelector((state) => state.user_info[0]?.user);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!location.pathname.startsWith("/admin/packages/view-receipt")) {
      localStorage.removeItem("paymentReceiptFromOnce");
    }
  }, [location]);

  const menuItems = [
    {
      path: "/admin",
      icon: <FiHome className="w-[18px] h-[18px]" />,
      title: "Dashboard",
    },
    {
      path: "/plot",
      icon: <BiLineChart className="w-[18px] h-[18px]" />,
      title: "Plots",
      submenu: [
        { path: "/admin/plot/add", title: "Add Plot" },
        { path: "/admin/plot/list", title: "Show Plot" },
      ],
    },
    {
      path: "/plan",
      icon: <MdOutlineEditCalendar className="w-[18px] h-[18px]" />,
      title: "Plans",
      submenu: [
        { path: "/admin/plan/add", title: "Add Plan" },
        { path: "/admin/plan/list", title: "Plan List" },
      ],
    },
    {
      path: "/gallery",
      icon: <MdPhotoLibrary className="w-[18px] h-[18px]" />,
      title: "Gallery",
      submenu: [
        { path: "/admin/gallery/add", title: "Add Gallery" },
        { path: "/admin/gallery/list", title: "Show Gallery" },
      ],
    },
    {
      path: "/news",
      icon: <MdArticle className="w-[18px] h-[18px]" />,
      title: "News",
      submenu: [
        { path: "/admin/news/add", title: "Add News" },
        { path: "/admin/news/list", title: "Show News" },
      ],
    },
    {
      path: "/withdrawal-requests",
      icon: <RiCoinsLine className="w-[18px] h-[18px]" />,
      title: "Withdrawals",
      submenu: [
        { path: "/admin/withdrawal-requests", title: "Manage Requests" },
      ],
    },
    {
      path: "/legal",
      icon: <FaGavel className="w-[18px] h-[18px]" />,
      title: "Legal",
      submenu: [
        { path: "/admin/legal/add", title: "Add Legal Document" },
        { path: "/admin/legal/list", title: "Show Legal Documents" },
      ],
    },
    {
      path: "/contact",
      icon: <AiOutlinePhone className="w-[18px] h-[18px]" />,
      title: "Contact",
      submenu: [
        { path: "/admin/contact/list", title: "Show Contact Details" },
      ],
    },
    {
      path: "/team-member",
      icon: <MdPersonAdd className="w-[18px] h-[18px]" />,
      title: "Team Members",
      submenu: [
        { path: "/admin/team-member/add", title: "Add Member" },
        { path: "/admin/team-member/list", title: "Member List" },
      ],
    },
    {
      path: "/packages",
      icon: <GoPackage className="w-[18px] h-[18px]" />,
      title: "Packages",
      submenu: [
        { path: "/admin/packages/add", title: "Add New Package" },
        { path: "/admin/packages/show", title: "Show All Packages" },
        { path: "/admin/packages/generate-receipt-manually", title: "Generate Receipt Manually" },
        { path: "/admin/packages/view-receipt", title: "View Receipt" },
        { path: "/admin/packages/month-wise-excel-report", title: "Month-Wise Report" },
      ],
    },
    {
      path: "/rewards",
      icon: <FiGift className="w-[18px] h-[18px]" />,
      title: "Rewards",
      submenu: [
        { path: "/admin/rewards/add", title: "Add New Reward" },
        { path: "/admin/rewards/list", title: "Show All Rewards" },
      ],
    },
    {
      path: "/users",
      icon: <FaUser className="w-[18px] h-[18px]" />,
      title: "All Users",
      submenu: [
        { path: "/admin/customer/list", title: "Customer List" },
        { path: "/admin/partner/list", title: "Partner List" },
        { path: "/admin/admin-network-explorer", title: "Network Explorer" },
      ],
    },
    {
      path: "/kyc",
      icon: <MdOutlinePendingActions className="w-[18px] h-[18px]" />,
      title: "KYC Approvals",
      submenu: [
        { path: "/admin/kyc-approval/list", title: "All KYC Approval List" },
      ],
    },
    {
      path: "/closing-report",
      icon: <TbReportAnalytics className="w-[18px] h-[18px]" />,
      title: "Closing Report",
      submenu: [
        { path: "/admin/closing-reports", title: "Check Closing Reports" },
      ],
    },
  ];

  useEffect(() => {
    if (!Array.isArray(menuItems)) return;
    const activeIndex = menuItems.findIndex(
      (item) =>
        item.submenu &&
        item.submenu.some((sub) => location.pathname === sub.path)
    );
    if (activeIndex !== -1) setActiveSubmenu(activeIndex);
  }, [location.pathname]);

  const toggleSubmenu = (index) => {
    setActiveSubmenu(activeSubmenu === index ? null : index);
  };

  const handleBack = () => navigate(-1);

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    setIsRefresh("adminlogg");
    dispatch(setValue("Logout"));
    navigate("/login");
  };

  const handleNavClick = () => {
    if (window.innerWidth < 1024) setSidebarOpen(false);
  };

  const isItemActive = (item) =>
    location.pathname === item.path ||
    (item.submenu &&
      item.submenu.some((sub) => location.pathname === sub.path));

  // Group labels for visual sections
  const sectionLabels = {
    0: "Overview",
    1: "Core",
    3: "Content",
    5: "Finance",
    6: "Legal & Support",
    8: "Management",
    11: "Compliance",
  };

  return (
    <div className="flex h-screen bg-[#F0F4FF] overflow-hidden">
      {/* ── Mobile backdrop ── */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.6 }}
            exit={{ opacity: 0 }}
            onClick={() => setSidebarOpen(false)}
            className="fixed inset-0 z-20 bg-black lg:hidden"
          />
        )}
      </AnimatePresence>

      {/* ═══════════════════════════════
          SIDEBAR
      ═══════════════════════════════ */}
      <motion.aside
        initial={{ x: -300 }}
        animate={{ x: sidebarOpen ? 0 : -300 }}
        transition={{ type: "spring", stiffness: 300, damping: 32 }}
        className="fixed inset-y-0 left-0 z-30 w-[260px] flex flex-col bg-white border-r border-[#E4EBFF] shadow-[4px_0_24px_rgba(37,35,98,0.06)] lg:static lg:translate-x-0"
        style={{ height: "100vh" }}
      >
        {/* ── Brand bar ── */}
        {/* <div className="flex items-center gap-3 px-5 h-[64px] border-b border-[#E4EBFF] shrink-0">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[#0EA5E9] to-[#2563EB] flex items-center justify-center shadow-md shadow-blue-200">
            <GiDiamondTrophy className="w-4 h-4 text-white" />
          </div>
          <span className="font-bold text-[15px] tracking-tight text-[#1E1B4B]">
            MLM<span className="text-[#2563EB]">Admin</span>
          </span>
          <button
            onClick={() => setSidebarOpen(false)}
            className="ml-auto lg:hidden text-gray-400 hover:text-gray-700"
          >
            <FiX className="w-5 h-5" />
          </button>
        </div> */}

        {/* ── Admin user card ── */}
        <div className="mx-3 mt-4 mb-2 rounded-xl bg-gradient-to-br from-[#1D4ED8] to-[#0EA5E9] p-4 text-white shadow-lg shadow-blue-200/60">
          <div className="flex items-center gap-3">
            <div className="relative shrink-0">
              <img
                src="/assets/profile-placeholder.jpg"
                alt="Admin"
                className="w-11 h-11 rounded-xl object-cover ring-2 ring-white/30"
              />
              <span className="absolute -bottom-1 -right-1 w-3.5 h-3.5 bg-emerald-400 rounded-full border-2 border-white" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-sm truncate leading-tight">
                {userData?.fullName}
              </p>
              <p className="text-[11px] text-blue-200 mt-0.5">
                ID: {userData?.sponsorCode}
              </p>
            </div>
            <div className="ml-auto shrink-0">
              <span className="inline-flex items-center gap-1 bg-white/15 backdrop-blur-sm px-2 py-1 rounded-full text-[10px] font-semibold border border-white/20">
                <FaCrown className="w-2.5 h-2.5 text-yellow-300" />
                Admin
              </span>
            </div>
          </div>
        </div>

        {/* ── Nav menu ── */}
        <nav
          className="flex-1 overflow-y-auto px-3 py-3 space-y-0.5"
          style={{ scrollbarWidth: "none" }}
        >
          {menuItems.map((item, index) => {
            const active = isItemActive(item);
            return (
              <div key={index}>
                {/* Section label */}
                {sectionLabels[index] && (
                  <p className="text-[10px] font-semibold uppercase tracking-widest text-gray-400 px-3 pt-3 pb-1.5">
                    {sectionLabels[index]}
                  </p>
                )}

                <Link
                  to={item.path}
                  onClick={(e) => {
                    if (item.submenu) {
                      e.preventDefault();
                      toggleSubmenu(index);
                    } else {
                      handleNavClick();
                    }
                  }}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-[13.5px] font-medium transition-all duration-150 group
                    ${
                      active
                        ? "bg-[#EFF6FF] text-[#2563EB]"
                        : "text-gray-500 hover:bg-gray-50 hover:text-gray-800"
                    }`}
                >
                  {/* Icon pill */}
                  <span
                    className={`flex items-center justify-center w-7 h-7 rounded-lg transition-all duration-150 shrink-0
                      ${
                        active
                          ? "bg-[#2563EB] text-white shadow-sm shadow-blue-300"
                          : "bg-gray-100 text-gray-500 group-hover:bg-gray-200 group-hover:text-gray-700"
                      }`}
                  >
                    {item.icon}
                  </span>

                  <span className="flex-1 leading-none truncate">{item.title}</span>

                  {item.submenu ? (
                    <FiChevronDown
                      className={`w-4 h-4 shrink-0 transition-transform duration-200 ${
                        activeSubmenu === index ? "rotate-180" : ""
                      } ${active ? "text-[#2563EB]" : "text-gray-400"}`}
                    />
                  ) : (
                    active && (
                      <span className="w-1.5 h-1.5 rounded-full bg-[#2563EB] shrink-0" />
                    )
                  )}
                </Link>

                {/* Submenu */}
                <AnimatePresence initial={false}>
                  {item.submenu && activeSubmenu === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.18 }}
                      className="overflow-hidden"
                    >
                      <div className="ml-[38px] mt-0.5 mb-1 border-l-2 border-[#E4EBFF] pl-3 space-y-0.5">
                        {item.submenu.map((sub) => {
                          const subActive = location.pathname === sub.path;
                          return (
                            <Link
                              key={sub.path}
                              to={sub.path}
                              onClick={handleNavClick}
                              className={`block py-2 px-2 rounded-lg text-[12.5px] transition-all duration-150
                                ${
                                  subActive
                                    ? "text-[#2563EB] font-semibold bg-[#EFF6FF]"
                                    : "text-gray-500 hover:text-gray-800 hover:bg-gray-50"
                                }`}
                            >
                              {sub.title}
                            </Link>
                          );
                        })}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </nav>

        {/* ── Logout ── */}
        <div className="p-3 border-t border-[#E4EBFF] shrink-0">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 w-full px-3 py-2.5 rounded-xl text-[13.5px] font-medium text-red-400 hover:bg-red-50 hover:text-red-600 transition-all duration-150 group"
          >
            <span className="flex items-center justify-center w-7 h-7 rounded-lg bg-red-50 group-hover:bg-red-100 transition-colors duration-150">
              <FiLogOut className="w-[17px] h-[17px]" />
            </span>
            Sign out
          </button>
        </div>
      </motion.aside>

      {/* ═══════════════════════════════
          MAIN COLUMN
      ═══════════════════════════════ */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* ── Top header ── */}
        <header className="shrink-0 flex items-center justify-between h-[64px] px-5 bg-white border-b border-[#E4EBFF] shadow-sm z-10">
          {/* Left */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => setSidebarOpen(true)}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-xl bg-gray-50 hover:bg-gray-100 text-gray-600 transition-colors"
            >
              <FiMenu className="w-5 h-5" />
            </button>

            {!location.pathname.match(/^\/admin$/) && (
              <button
                onClick={handleBack}
                className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500 hover:text-[#2563EB] transition-colors"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-gray-50 hover:bg-[#EFF6FF]">
                  <FiArrowLeft className="w-4 h-4" />
                </div>
                <span className="hidden sm:block">Back</span>
              </button>
            )}

            {/* Page title */}
            <span className="hidden md:block text-[13px] font-semibold text-[#1E1B4B] pl-1">
              {menuItems.find(
                (m) =>
                  m.path === location.pathname ||
                  (m.submenu &&
                    m.submenu.some((s) => s.path === location.pathname))
              )?.title ?? "Admin Panel"}
            </span>
          </div>

          {/* Right */}
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline-flex items-center gap-1.5 bg-[#EFF6FF] text-[#2563EB] text-[12px] font-semibold px-3 py-1.5 rounded-full">
              <GiDiamondTrophy className="w-3.5 h-3.5" />
              Administrator
            </span>
            <div className="relative">
              <img
                src="/assets/profile-placeholder.jpg"
                alt="Admin avatar"
                className="w-9 h-9 rounded-xl object-cover ring-2 ring-[#E4EBFF] hover:ring-[#2563EB] transition-all duration-150 cursor-pointer"
              />
              <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-emerald-400 rounded-full border-2 border-white" />
            </div>
          </div>
        </header>

        {/* ── Scrollable main area ── */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden bg-[#F0F4FF]">
          <div className="max-w-7xl mx-auto p-4 sm:p-6">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.22 }}
              className="bg-white rounded-2xl shadow-sm border border-[#E4EBFF] p-5 sm:p-7 min-h-[calc(100vh-120px)]"
            >
              <Outlet />
            </motion.div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;